<template>
    <ModalTemplate
      :isOpen="isOpen"
      :on-close="onClose"
      :modalMainContainerClass="'preview_coupon_modal'"
      :title="$t('COUPON.PREVIEW_MODAL.TITLE')"
    >
        <div class="mt_20">

            <!-- <div class="template">
                <div class="heading">
                    <aside>
                        <p class="shortcut">{{coupon.code}}</p>
                        <h4 class="title font_14_5">{{coupon.name}}</h4>
                    </aside>
                    <aside>
                        <div style="display:flex;">
                            <div>
                                <Label :title="coupon.status" :colorScheme="status_color" />
                            </div>
                        </div>
                    </aside>
                </div>
            </div> -->

            <section class="col_preview preview">
                <div class="pre_header">
                    <h3 class="title">{{$t('MESSAGE_MGMT.ADD.PREVIEW.TITLE')}}</h3>
                </div>
                <div class="pre_message_box">
                    <div class="preview_card">
                        <div class="mb_10">
                            <p class="font_regular font_500 text_14">CODE: {{coupon.code}}</p>
                            <p class="font_regular font_500 text_14">{{coupon.footer}}</p>
                        </div>
                        <div class="media">
                            <!-- <div class="arrow_mark"></div> -->
                            <template>
                                <div class="file_view_wrapper" v-if="coupon.image">
                                    <img :src="coupon.image" alt="">
                                </div>
                            </template>
                        </div>
                        <div class="msg_content">
                            <!-- <p>CODE: {{coupon.code}}</p>
                            <p>{{coupon.name}}</p>
                            <p>{{coupon.footer}}</p> -->
                            <time>{{getCurrentTime()}}</time>
                        </div>
                        <!-- <div v-if="buttonsData.length" class="buttons">
                            <div class="btn_wrapper">
                                <a v-for="buttonEl in buttonsData" :key="buttonEl.code">
                                {{ buttonEl.name }}
                                </a>
                            </div>
                        </div> -->
                    </div>
                </div>
            </section>

            <div class="pre_btns">
                <woot-button class-names="pre_close" variant="clear" @click="onClose">
                {{$t("MESSAGE_MGMT.PREVIEW.BTNS.CLOSE")}}
                </woot-button>
            </div>
        </div>
    </ModalTemplate>
</template>

<script>
import ModalTemplate from 'dashboard/components/ModalTemplate.vue';
import SHImage from "../../../../../shopApp/routes/shop/components/SHImage.vue"
import Label from 'dashboard/components/ui/Label';
import moment from "moment";

export default {
    components: {
        ModalTemplate,
        SHImage,
        Label,
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        coupon: {
            type: Object,
            default: () => {},
        },
    },
    computed:{
        status_color(){
            const colorScheme =
                this.coupon.status === 'active'
                ? 'green_pro'
                : this.coupon.status === 'inactive'
                ? 'gray_pro'
                :  this.coupon.status === 'expired'
                ? 'warning_pro'
                :  this.coupon.status === 'limit_reached'
                ? 'primary_pro'
                : 'gray_pro';
            return colorScheme;
        },
    },
    methods:{
        onClose(){
            this.$emit('onClose')
        },
        getCurrentTime() {
            const now = moment();
            return now.format('h:mm A'); // 8:04 AM
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.template{
    border-radius: 10px;
    margin-top: var(--space-normal);
    .heading{
        display: flex;
        justify-content: space-between;
        gap: 16px;

        .shortcut{
            font-weight: 700;
            font-size: var(--font-size-small);
            color: #8D25F6;
        }
        .title{
            font-weight: 500;
            font-size: var(--font-size-small);
            color: #1F1F1F;
            margin-top: 4px;
        }
        .status{
            font-size: var(--font-size-mini);
            padding: 5px 12px;
        }
        // .rejected{
        //     color: #E50000;
        //     background: #FFE5E5;
        // }
        // .approved{
        //     color: #24B200;
        //     background: #EBFCC0;
        // }
        // .pending{
        //     color: #FFAA00;
        //     background: #FFF4E5;
        // }
    }
    .btns{
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        margin-top: var(--space-slab);
        button{
            font-weight: 500;
            font-size: var(--font-size-small);
            color: #858585;
        }
    }
}
.coupon_img{
    width: 190px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 12px;
    overflow: hidden;
}

// Preview START
.col_preview{
    position: relative;
    min-height: 100%;
    // background: #00000082;
    // background-image: url('../../../../assets/images/background/whatsapp_bg.jpeg');
    background-image: url('../../../../assets/images/background/whatsapp_bg.jpeg');
    background-size: cover;
    margin-top: 24px;
}

.col_preview::before{
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.02);
}
.preview{
    .pre_header{
        padding: var(--space-slab);
        background-color: #F2E7FE;
        .title{
            font-weight: 700;
            font-size: var(--font-size-small);
            color: #8D25F6;
        }
    }
    .pre_message_box{
        padding: 20px 12px;
    }
}

.preview_card{
    position: relative;
    // max-width: 90%;
    // margin: 20px 12px;
    background-color: #fff;
    padding: 8px 12px;
    border-radius: 4px;

    .arrow_mark{
        width: 20px;
        height: 20px;
        background: #fff;
        position: absolute;
        top: 0;
        left: -15px;
        clip-path: polygon(0 0, 100% 100%, 100% 0);
    }

    .media{
        max-height: 220px;
        overflow: hidden;

        .file_view_wrapper{
            position: relative;
            width: 100%;
            height: 220px;

            img,video,iframe{
                position: absolute;
                width: 100%;
                height: auto;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
            }
        }
    }
    .msg_content{
        position: relative;
        min-height: 10px;
        margin-bottom:  var(--space-small);
        padding: var(--space-one) var(--space-slab);
        p{
            white-space: pre-wrap;
            margin: 0;
        }
        .placeholder{
            color: #BBBBBB;
            font-size: var(--font-size-small);
            font-weight: 500;
        }
        time{
            position: absolute;
            width: 45px;
            height: 10px;
            right: 0;
            bottom: -5px;
            color: #8492a6;
        }
    }
    .buttons{

        .btn_wrapper{
            padding: 4px;

            a{
                display: block;
                text-align: center;
                padding: 5px;
                border-top: 1px solid #ebf0f5;
            }
        }
    }
}
.pre_btns{
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
    background: #fff;
    .pre_delete{
        font-weight: 700;
        font-size: var(--font-size-small) !important;
        color: #E50000 !important;
    }
    .pre_close{
        font-weight: 700;
        font-size: var(--font-size-small) !important;
        color: #8D25F6 !important;
    }
}

// Preview END
</style>

<style>
.preview_coupon_modal{
    width: 60rem !important;
}
</style>